import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() navClass: string;
  isCondensed = false;
  kurumsalAktif = false;
  private sub: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.guncelle();
    this.sub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isCondensed = false;
        this.guncelle();
      }
    });
  }

  private guncelle() {
    const yol = this.router.url.split('?')[0].split('#')[0];
    this.kurumsalAktif = ['/aboutus', '/privacy', '/termsconditions', '/contact'].indexOf(yol) !== -1;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  toggleMenu() {
    this.isCondensed = !this.isCondensed;
  }
}
